import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Plans } from '../constants';

const OptionButtons = ({
  handleChange,
  selected,
  getCouponContentKey,
  defaultSeasonalTitle,
  defaultSeasonalPrice,
  defaultSeasonalSubText,
  defaultAnnualTitle,
  defaultAnnualPrice,
  defaultAnnualSubText,
  strikethroughText,
  boldAnnualSubText,
}) => {
  const seasonalTitle = defaultSeasonalTitle || 'SEASONAL';
  const seasonalPrice = defaultSeasonalPrice || '$49.99 USD';
  const seasonalSubText = defaultSeasonalSubText || 'Standard';
  const annualTitle = defaultAnnualTitle || 'ANNUAL';
  const annualPrice = defaultAnnualPrice || '$199.99 USD';
  const annualSubText = defaultAnnualSubText || '$179.99 USD!';
  return (
    <div className="trial-upgrade__buttons">
      <div
        className={cx('trial-upgrade__buttons__box', { active: selected === Plans.SEASONAL })}
        role="button"
        tabIndex="0"
        onClick={() => handleChange(Plans.SEASONAL)}
        onKeyDown={() => handleChange(Plans.SEASONAL)}
      >
        {selected === Plans.SEASONAL && <div className="active-check"><i className="fas fa-check-circle" /></div>}
        <div className="trial-upgrade__buttons__title">
          {getCouponContentKey('seasonalPlan.title', seasonalTitle)}
        </div>
        <div className="trial-upgrade__buttons__price">
          {getCouponContentKey('seasonalPlan.subtitle', seasonalPrice)}
        </div>
        <div className="trial-upgrade__buttons__type">
          {getCouponContentKey('seasonalPlan.note', seasonalSubText)}
        </div>
      </div>
      <div
        className={cx('trial-upgrade__buttons__box', { active: selected === Plans.ANNUAL })}
        role="button"
        tabIndex="0"
        onClick={() => handleChange(Plans.ANNUAL)}
        onKeyDown={() => handleChange(Plans.ANNUAL)}
      >
        {selected === Plans.ANNUAL && <div className="active-check"><i className="fas fa-check-circle" /></div>}
        <div className="trial-upgrade__buttons__title">
          {getCouponContentKey('annualPlan.title', annualTitle)}
        </div>
        <div className={cx('trial-upgrade__buttons__price', { through: strikethroughText })}>
          {getCouponContentKey('annualPlan.subtitle', annualPrice)}
        </div>
        <div className={
          cx('spaced',
            {
              'trial-upgrade__buttons__price': boldAnnualSubText,
              'trial-upgrade__buttons__type': !boldAnnualSubText,
            })
        }
        >
          {getCouponContentKey('annualPlan.note', annualSubText)}
        </div>
      </div>
    </div>
  );
};

OptionButtons.defaultProps = {
  handleChange: () => null,
  selected: Plans.SEASONAL,
  getCouponContentKey: (key, defaultValue) => (defaultValue),
  defaultSeasonalTitle: '',
  defaultSeasonalPrice: '',
  defaultSeasonalSubText: '',
  defaultAnnualTitle: '',
  defaultAnnualPrice: '',
  defaultAnnualSubText: '',
  strikethroughText: true,
  boldAnnualSubText: true,
};

OptionButtons.propTypes = {
  handleChange: PropTypes.func,
  selected: PropTypes.string,
  getCouponContentKey: PropTypes.func,
  defaultSeasonalTitle: PropTypes.string,
  defaultSeasonalPrice: PropTypes.string,
  defaultSeasonalSubText: PropTypes.string,
  defaultAnnualTitle: PropTypes.string,
  defaultAnnualPrice: PropTypes.string,
  defaultAnnualSubText: PropTypes.string,
  strikethroughText: PropTypes.bool,
  boldAnnualSubText: PropTypes.bool,
};

export default OptionButtons;
